export enum Status {
  ONGOING = 'ongoing',
  FINALIZED = 'finalized',
}
